import { PAGE_STATE_DURING_EVENT } from 'common/constants/virtualEvent';
import buildIDWithStateScope from 'common/compounds/VirtualEventBuilder/utils/buildIDWithStateScope';

import SideBySideIcon from 'common/icons/SideBySide';
import StackIcon from 'common/icons/Stack';
import SidebarIcon from 'common/icons/Sidebar';

function generateId(id) {
    return buildIDWithStateScope(id, PAGE_STATE_DURING_EVENT);
}

export const NODE_ID_PAGE_CONTAINER = generateId('body');
export const NODE_ID_HEADER = generateId('header');
export const NODE_ID_HEADLINE = generateId('headline');
export const NODE_ID_LOGO = generateId('logo');
export const NODE_ID_VIRTUAL_CONTENT = generateId('virtualContent');
export const NODE_ID_EMBED = generateId('embed');
export const NODE_ID_ALT_EMBED = generateId('altEmbed');
export const NODE_ID_LINK_OUT = generateId('linkOut');
export const NODE_ID_ZOOM_LINK_OUT = generateId('zoomLinkOut');
export const NODE_ID_FOOTER_CONTAINER = generateId('footer');
export const NODE_ID_CONTACT_ORGANIZER_BUTTON = generateId('contact');
export const NODE_ID_VISIT_EVENT_PAGE_BUTTON = generateId('eventPage');
export const NODE_ID_CUSTOM_BUTTON = generateId('footerCta');
export const NODE_ID_CUSTOM_BUTTON_TWO = generateId('customButtonTwo');

export const NODE_DISPLAY_NAME_PAGE_CONTAINER = 'Page';
export const NODE_DISPLAY_NAME_HEADER = 'Header';
export const NODE_DISPLAY_NAME_HEADLINE = 'Event Title';
export const NODE_DISPLAY_NAME_LOGO = ' Logo';
export const NODE_DISPLAY_NAME_VIRTUAL_CONTENT = 'Virtual Content';
export const NODE_DISPLAY_NAME_EMBED = 'Embed';
export const NODE_DISPLAY_NAME_ALT_EMBED = 'Alt Embed';
export const NODE_DISPLAY_NAME_LINK_OUT = 'Link Out';
export const NODE_DISPLAY_NAME_ZOOM_LINK_OUT = 'Zoom Link Out';
export const NODE_DISPLAY_NAME_FOOTER_CONTAINER = 'Footer';
export const NODE_DISPLAY_NAME_CONTACT_ORGANIZER_BUTTON = 'Contact Organizer Button';
export const NODE_DISPLAY_NAME_VISIT_EVENT_PAGE_BUTTON = 'Visit Event Page Button';
export const NODE_DISPLAY_NAME_CUSTOM_BUTTON = 'Custom Button One';
export const NODE_DISPLAY_NAME_CUSTOM_BUTTON_TWO = 'Custom Button Two';

export const VIRTUAL_CONTENT_TYPE_EMBED = 'embed';
export const VIRTUAL_CONTENT_TYPE_LINK_OUT = 'link_out';
export const SIDEBAR_PORTAL_ID = 'embedSidebarPortal';

export const SIDE_BY_SIDE_LAYOUT_LABEL = 'Side by Side';
export const STACK_LAYOUT_LABEL = 'Stack';
export const SIDEBAR_LAYOUT_LABEL = 'Sidebar';
export const SIDE_BY_SIDE_LAYOUT = 'sideBySide';
export const STACK_LAYOUT = 'stacked';
export const SIDEBAR_LAYOUT = 'sidebar';

export const EMBED_TYPES = {
    ZOOM: 'zoom',
    CUSTOM: 'raw',
    VIMEO: 'vimeo',
    INTROVOKE: 'introvoke',
    GOLDCAST: 'goldcast',
};

export const HEADER_LAYOUT_OPTIONS = [SIDE_BY_SIDE_LAYOUT, STACK_LAYOUT];
export const HEADER_LAYOUT_OPTIONS_WITH_ICONS = [
    {
        layout: SIDE_BY_SIDE_LAYOUT,
        Icon: SideBySideIcon,
        label: SIDE_BY_SIDE_LAYOUT_LABEL,
    },
    {
        layout: STACK_LAYOUT,
        Icon: StackIcon,
        label: STACK_LAYOUT_LABEL,
    },
];

export const VIRTUAL_CONTENT_LAYOUT_OPTIONS = [SIDE_BY_SIDE_LAYOUT, STACK_LAYOUT, SIDEBAR_LAYOUT];
export const VIRTUAL_CONTENT_LAYOUT_OPTIONS_WITH_ICONS = [
    {
        layout: SIDEBAR_LAYOUT,
        Icon: SidebarIcon,
        label: SIDEBAR_LAYOUT_LABEL,
    },
    {
        layout: SIDE_BY_SIDE_LAYOUT,
        Icon: SideBySideIcon,
        label: SIDE_BY_SIDE_LAYOUT_LABEL,
    },
    {
        layout: STACK_LAYOUT,
        Icon: StackIcon,
        label: STACK_LAYOUT_LABEL,
    },
];
